"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessInformation = void 0;
const BusinessKrn_1 = require("./businessinformation/BusinessKrn");
const CompanyName_1 = require("./businessinformation/CompanyName");
const FcaNumber_1 = require("./businessinformation/FcaNumber");
const IsRegistered_1 = require("./businessinformation/IsRegistered");
const LegalForm_1 = require("./businessinformation/LegalForm");
const OperationalAddress_1 = require("./businessinformation/OperationalAddress");
const Persons_1 = require("./businessinformation/Persons");
const ProductChannel_1 = require("./businessinformation/ProductChannel");
const RegisteredAddress_1 = require("./businessinformation/RegisteredAddress");
const RegistrationAuthority_1 = require("./businessinformation/RegistrationAuthority");
const RegistrationCountry_1 = require("./businessinformation/RegistrationCountry");
const RegistrationId_1 = require("./businessinformation/RegistrationId");
const ShouldAutoCaptureOrders_1 = require("./businessinformation/ShouldAutoCaptureOrders");
const SubjectToVat_1 = require("./businessinformation/SubjectToVat");
const VatId_1 = require("./businessinformation/VatId");
exports.BusinessInformation = {
    business_krn: BusinessKrn_1.BusinessKrn,
    company_name: CompanyName_1.CompanyName,
    fca_number: FcaNumber_1.FcaNumber,
    is_registered: IsRegistered_1.IsRegistered,
    legal_form: LegalForm_1.LegalForm,
    operational_address: OperationalAddress_1.OperationalAddress,
    persons: Persons_1.Persons,
    product_channel: ProductChannel_1.ProductChannel,
    registered_address: RegisteredAddress_1.RegisteredAddress,
    registration_authority: RegistrationAuthority_1.RegistrationAuthority,
    registration_country: RegistrationCountry_1.RegistrationCountry,
    registration_id: RegistrationId_1.RegistrationId,
    should_auto_capture_orders: ShouldAutoCaptureOrders_1.ShouldAutoCaptureOrders,
    subject_to_vat: SubjectToVat_1.SubjectToVat,
    vat_id: VatId_1.VatId,
};
